/**
 * `chartType` values accepted by ui:metricChart, mapped to the Perses panel plugin kind. Every entry
 * must be a panel that accepts `TimeSeriesQuery` (Perses' ScatterChart, for example, only takes
 * traces) and must be registered in perses-panel-host's plugin loader.
 */
export const CHART_TYPES = {
  timeSeries: 'TimeSeriesChart',
  stat: 'StatChart',
  gauge: 'GaugeChart',
  pie: 'PieChart',
  table: 'Table',
  histogram: 'HistogramChart',
  heatmap: 'HeatMapChart',
} as const

export type ChartType = keyof typeof CHART_TYPES
export type PanelKind = (typeof CHART_TYPES)[ChartType]
